import { featureFlags } from "src/config";
import { Provider } from "../types";

export function getSelectedProvider() {
  const provider = localStorage.getItem("provider");
  if (!provider) return undefined;

  return JSON.parse(provider) as Provider;
}

export function storeLocalStorageData(
  provider: Provider,
  serviceId: string,
  callbackUrl: string
) {
  localStorage.setItem("providerId", provider.id);
  localStorage.setItem("providerName", provider.name);
  localStorage.setItem("serviceId", serviceId);
  localStorage.setItem("callbackUrl", callbackUrl);
  localStorage.setItem("provider", JSON.stringify(provider));
  localStorage.setItem(
    "providerUrl",
    buildProviderUrl(provider, serviceId, callbackUrl)
  );
}

function buildProviderUrl(
  provider: Provider,
  serviceId: string,
  callbackUrl: string
) {
  let url = "";

  if (provider.is_new_integration) {
    if (!provider.url.includes("?")) {
      url = `${provider.url}?redirect_uri=${callbackUrl}`;
    } else {
      url = `${provider.url}&redirect_uri=${callbackUrl}`;
    }

    return url;
  }

  const providerUrl = provider.is_default_authentication
    ? provider.url
    : `/signin?logo=${provider.logo}&name=${provider.name}`;

  return `/providers/${provider.id}/services/${serviceId}?callback=${callbackUrl}&provider_callback_url=${providerUrl}&flow=alf`;
}

function SelectProvider(
  provider: Provider,
  serviceId: string,
  callbackUrl: string
) {
  storeLocalStorageData(provider, serviceId, callbackUrl);

  if (featureFlags.VERIFY_ASSOCIATION) {
    window.location.href = "/verify";
    return;
  }

  if (provider.is_new_integration) {
    window.location.href = "/redirect";
    return;
  }

  window.location.href = buildProviderUrl(provider, serviceId, callbackUrl);
  return;
}

export default SelectProvider;
